import { render, staticRenderFns } from "./EditPanelHeader.vue?vue&type=template&id=10d58173&scoped=true&"
import script from "./EditPanelHeader.vue?vue&type=script&lang=js&"
export * from "./EditPanelHeader.vue?vue&type=script&lang=js&"
import style0 from "./EditPanelHeader.vue?vue&type=style&index=0&id=10d58173&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d58173",
  null
  
)

export default component.exports